<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Aclmcx/tc-custom/9781614759775.jpg?1704537901049" alt="This image is the cover for the book River Runs Red"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">River Runs Red
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Three friends return to their Texas hometown, and a supernatural war that will decide the fate of worlds, in this horror thriller.</b></p><p> As teenagers, Molly, Byrd, and Wade faced inconceivable evil in an underground labyrinth on the banks of the Rio Grande. Now they are reunited as adults, about to discover that their terrifying experience was only the beginning. </p> Something has drawn the three friends back to their small Texas town and the caves in which they faced their fate. A mysterious force is plunging them into a supernatural war that spans across the globe, through raging rivers, mysterious murders, long-buried gods, and secrets worth dying—or killing—for.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey J Mariotte
      </h2>
      
      <p class="authorDescription body article"> Jeffrey J. Mariotte has written more than seventy novels, including original supernatural thrillers River Runs Red and Cold Black Hearts, horror epic The Slab, and the Stoker Award-nominated teen horror quartet Dark Vengeance. Other works include the acclaimed thrillers Empty Rooms and The Devil&rsquo;s Bait, and&mdash;with his wife and writing partner Marsheila (Marcy) Rockwell, the science fiction thriller 7 SYKOS and Mafia III: Plain of Jars, the authorized prequel to the hit video game, as well as numerous shorter works. He has also written novels set in the worlds of Star Trek, CSI, NCIS, Narcos, Deadlands, 30 Days of Night, Spider-Man, Conan, Buffy the Vampire Slayer and Angel, and more. Two of his novels have won Scribe Awards for Best Original Novel, presented by the International Association of Media Tie-In Writers. He is also the author of many comic books and graphic novels, including the original Western series Desperadoes, some of which have been nominated for Stoker and International Horror Guild Awards. Other comics work includes the horror series Fade to Black, action-adventure series Garrison, and the original graphic novel Zombie Cop. He is a member of the International Thriller Writers, Sisters in Crime, and the International Association of Media Tie-In Writers. He has worked in virtually every aspect of the publishing businesses, as a bookseller, VP of Marketing for Image Comics/WildStorm, Senior Editor for DC Comics/WildStorm, and the first Editor-in-Chief for IDW Publishing. When he&rsquo;s not writing, reading, or editing something, he&rsquo;s probably out enjoying the desert landscape around the Arizona home he shares with his family and dog and cat. Find him online at www.jeffmariotte.com, www.facebook.com/JeffreyJMariotte, and @JeffMariotte. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?710e1c18